module.exports = __webpack_public_path__ + "img/issue-icon16.a755a47.png";